import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { CommunityType } from './types'

interface NewProps {
  community: CommunityType
}

export default function New({ community }: NewProps) {
  return (
    <>
      <Head title="New community" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8 text-foreground">
        <h1 className="font-bold text-4xl">New community</h1>

        <Form
          community={community}
          method="post"
          action="/communities"
          submitText="Create Community"
        />

        <Link
          href="/communities"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Back to communities
        </Link>
      </div>
    </>
  )
}
